import React from 'react';

import { propTypes } from './option';
import OptionRow from './option_row';
import Toggle from 'components/toggle';

class Bool extends React.Component {
  static propTypes = propTypes
  static type = 'bool'

  static defaultProps = {
    value: false
  }

  handleChange = (event) => {
    this.props.onChange({ [this.props.option.id]: event.target.checked });
  }

  renderInputs = () => {
    return <React.Fragment>
      {this.props.overrideMode ? <span className="bool-status-label">Status:</span> : null}
      <Toggle
        checked={this.props.value}
        disabled={this.props.disabled}
        theme={this.props.admin ? 'dark' : null}
        onChange={this.handleChange}
      />
    </React.Fragment>;
  }

  renderHiddenValue = () => {
    return `Hidden (${this.props.value ? 'Checked' : 'Unchecked'})`;
  }

  render() {
    return (
      <OptionRow
        {...this.props}
        renderHiddenValue={this.renderHiddenValue}
        renderInputs={this.renderInputs}
      />
    );
  }
}

export default Bool;
